export default "__VITE_ASSET__BPUgK$kl__"